export const PALLETS_FEATURE_KEY = 'pallets';
